import React, { useState } from "react";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from "../redux/usersSagas";
import { SearchInput } from "../../../../components/form/Input/Input";

const filterByOptions = [
  { id: "type", name: "User Type" },
  { id: "roles", name: "Role" },
  { id: "locations", name: "Location Access" },
  { id: "search", name: "User Name or Email" }
];

const dropdownSettings = {
  type: "user_type",
  roles: "role_id",
  locations: "selected_store_ids",
  search: "search_request"
};

export default function FilterUsers() {
  const dispatch = useDispatch();
  const {
    roles,
    locations,
    filters: { user_type }
  } = useSelector((state) => state.users.commonSettings);

  const [selectedFilterByOption, setSelectedFilterByOption] = useState(null);

  const [currentFilter, setCurrentFilter] = useState({ type: null, data: null });

  const onFilterByChange = (data) => {
    if (selectedFilterByOption && selectedFilterByOption.id == data.id) {
      setSelectedFilterByOption(null);
      setCurrentFilter({ type: null, data: null });
      return;
    }
    setSelectedFilterByOption(data);
    setCurrentFilter({ type: data.id, data: null });
  };

  const onChange = (data, type) => {
    setCurrentFilter({ data, type });
  };

  const onUpdate = () => {
    dispatch(fetchUsers({ key: [dropdownSettings[currentFilter.type]], data: currentFilter.data }));
  };

  return (
    <div className="users__filters">
      <div className="users__filterBy">
        <p>Filter By:</p>
        <Dropdown
          height={275}
          haveOnSelectChange
          placeholder="Please choose filter type"
          options={filterByOptions}
          selectedFilters={selectedFilterByOption}
          numberDisplayed={1}
          onSelectChange={onFilterByChange}
        />
      </div>
      <div className="users__filters-dynamic">
        {selectedFilterByOption && (
          <>
            {selectedFilterByOption.id == "type" && (
              <Dropdown
                height={275}
                haveOnSelectChange
                placeholder="Please choose user type"
                options={user_type}
                selectedFilters={currentFilter.data}
                numberDisplayed={1}
                onSelectChange={(data) => onChange(data, "type")}
              />
            )}
            {selectedFilterByOption.id == "roles" && (
              <Dropdown
                height={275}
                haveOnSelectChange
                placeholder="Please choose role"
                options={roles}
                selectedFilters={currentFilter.data}
                numberDisplayed={0}
                onSelectChange={(data) => onChange(data, "roles")}
              />
            )}
            {selectedFilterByOption.id == "locations" && (
              <Dropdown
                height={275}
                haveOnSelectChange
                placeholder="Please choose location"
                enableOnly
                options={locations}
                selectedFilters={currentFilter.data ?? []}
                numberDisplayed={0}
                onSelectChange={(data) => onChange(data, "locations")}
              />
            )}
            {selectedFilterByOption.id == "search" && (
              <div className="search">
                <SearchInput
                  placeholder="Search..."
                  value={currentFilter.data ?? ""}
                  onChange={(value) => onChange(value, "search")}
                  onClear={() => setCurrentFilter((prev) => ({ ...prev, data: "" }))}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && currentFilter.data) {
                      onUpdate();
                    }
                  }}
                />
              </div>
            )}
          </>
        )}
      </div>
      {currentFilter.data && (
        <button className="button button--primary" onClick={onUpdate}>
          Update
        </button>
      )}
    </div>
  );
}
